/**
 * Micro-Conversion Tracking for Rafturi-Comerciale.ro
 * Sends events to Google Ads via gtag() for Quality Score optimization
 *
 * Conversion Labels (Google Ads):
 *   scroll_75       → JcAaCNDc3I0cEPLz6M8_
 *   time_60s        → M6hICIHq3I0cEPLz6M8_
 *   mai_mult_click  → PnBjCOTz3I0cEPLz6M8_
 *   phone_click     → OclbCP-h3o0cEPLz6M8_
 *   email_click     → ffLCMDO3oOcEPLz6M8_
 *   whatsapp_click  → I3p8CMPO3o0cEPLz6M8_
 *   page_depth_3    → jdp9CN_Y3o0cEPLz6M8_
 *   price_table     → R4VcCNif540cEPLz6M8_
 */

(function () {
  'use strict';

  // Guard: gtag must be loaded
  if (typeof gtag !== 'function') return;

  var AW_ID = 'AW-17078827506';
  var sent = {}; // dedup flags – each event fires at most once per page view

  function fire(label, value) {
    if (sent[label]) return;
    sent[label] = true;
    gtag('event', 'conversion', {
      send_to: AW_ID + '/' + label,
      value: value,
      currency: 'RON'
    });
  }

  // ──────────────────────────────────────────────
  // 1. Scroll %75+
  // ──────────────────────────────────────────────
  function getScrollPercent() {
    var h = document.documentElement;
    var b = document.body;
    var st = window.pageYOffset || h.scrollTop || b.scrollTop || 0;
    var sh = Math.max(
      h.scrollHeight, b.scrollHeight,
      h.offsetHeight, b.offsetHeight,
      h.clientHeight, b.clientHeight
    );
    var ch = window.innerHeight || h.clientHeight;
    return Math.round((st / (sh - ch)) * 100);
  }

  window.addEventListener('scroll', function () {
    if (getScrollPercent() >= 75) {
      fire('JcAaCNDc3I0cEPLz6M8_', 1.0);
    }
  }, { passive: true });

  // ──────────────────────────────────────────────
  // 2. 60+ saniye sayfada kalma
  // ──────────────────────────────────────────────
  setTimeout(function () {
    fire('M6hICIHq3I0cEPLz6M8_', 2.0);
  }, 60000);

  // ──────────────────────────────────────────────
  // 3. "Mai mult" / Details tıklama
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('summary, .faq-item__question, [data-track="mai-mult"]');
    if (summary) {
      fire('PnBjCOTz3I0cEPLz6M8_', 2.0);
    }
  });

  // ──────────────────────────────────────────────
  // 4. Telefon numarası tıklama
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="tel:"], [data-track="phone"]');
    if (link) {
      fire('OclbCP-h3o0cEPLz6M8_', 20.0);
    }
  });

  // ──────────────────────────────────────────────
  // 5. WhatsApp butonu tıklama
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="wa.me"], [data-track="whatsapp"]');
    if (link) {
      fire('I3p8CMPO3o0cEPLz6M8_', 50.0);
    }
  });

  // ──────────────────────────────────────────────
  // 6. Email tıklama
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="mailto:"], [data-track="email"]');
    if (link) {
      fire('ffLCMDO3oOcEPLz6M8_', 30.0);
    }
  });

  // ──────────────────────────────────────────────
  // 7. Fiyat tablosuna tıklama
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.product-card__price, [data-track="price-table"], .price-table');
    if (el) {
      fire('R4VcCNif540cEPLz6M8_', 5.0);
    }
  });

  // ──────────────────────────────────────────────
  // 8. 3+ ürün sayfası görüntüleme (sayfa derinliği)
  // ──────────────────────────────────────────────
  (function () {
    var STORAGE_KEY = 'rc_page_depth';
    var count = 1;
    try {
      count = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10) + 1;
      sessionStorage.setItem(STORAGE_KEY, count.toString());
    } catch (e) {
      // sessionStorage unavailable
    }
    if (count >= 3) {
      fire('jdp9CN_Y3o0cEPLz6M8_', 5.0);
    }
  })();

  // ──────────────────────────────────────────────
  // 9. Telefon numarasını göster (numara kopyalama)
  // ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track="show-phone"]');
    if (el) {
      fire('OclbCP-h3o0cEPLz6M8_', 20.0);
    }
  });

})();
